import React, { useState, useEffect } from "react";
// import { DropdownButton, Dropdown } from "react-bootstrap";
import config from "../../../config/config";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { thunkLogoutUser } from "../../../redux/reducers/user_info/userInfoReducer";
import navigationsLinks, {
  BOXIGO_WEBSITE_LINKS,
} from "../../../constants/navigation_links";

export default function Header() {
  const history = useHistory();
  const userInfo = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const route = useRouteMatch();
  const [showMobileNav, setShowMobileNav] = useState(false);
  useEffect(() => {
    if (showMobileNav === true) {
      document
        .getElementsByTagName("body")[0]
        .classList.add("sidebar-restrict");
    } else if (showMobileNav === false) {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("sidebar-restrict");
    }
  }, [showMobileNav]);
  const hideTopServicesLinks = (route) => {
    const linksToCheck = ["/my-profile", "/dashboard"];
    let showNav = true;
    linksToCheck.forEach((link) => {
      if (route.path === link) {
        showNav = true;
      }
    });
    return showNav;
  };
  const JSX = (
    <>
      <header className="container-fluid">
        <div
          className={`header-top-section row ${
            hideTopServicesLinks(route) === true ? "d-none" : ""
          }`}
        >
          <div className="contact col-md-3 col-lg-3 col-xl-3">
            <a
              // onclick="return gtag_report_conversion('tel:+918884448117');"
              href="tel:+918884448117"
            >
              <img
                src={config.customerPortal + "assets/images/home/whatsapp.png"}
                alt="Whatsapp Us"
              />{" "}
              +91 88844 48117{" "}
            </a>
          </div>
          <div className="quick-links col-md-9 col-lg-9 col-xl-9">
            <ul className="text-right">
              <li>
                {" "}
                <a href={BOXIGO_WEBSITE_LINKS.home_page} className="">
                  {" "}
                  RELOCATION{" "}
                </a>{" "}
              </li>
              <li>
                {" "}
                <a href={BOXIGO_WEBSITE_LINKS.storage_space} className="">
                  {" "}
                  STORAGE SPACE{" "}
                </a>{" "}
              </li>
            </ul>
          </div>
        </div>
        <div className="main-header row">
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4">
            <div className="brand-logo-container">
              <div>
                <a href={`${config.customerPortal}`}>
                  <img
                    className="img-fluid logo"
                    src={`${config.customerPortal}assets/images/home/boxigo_logo_small.png`}
                    alt="Boxigo"
                  />
                </a>
              </div>
              <button
                type="button"
                className="nav-toggle-btn d-none"
                onClick={() => setShowMobileNav(!showMobileNav)}
              >
                <img
                  src={`${config.customerPortal}assets/images/icons/menu.png`}
                  className="img-fluid"
                  alt="menu"
                />{" "}
              </button>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8 navigation-container">
            <div
              className={`backdrop-container activate-navigation ${
                showMobileNav && "show-backdrop-container"
              }`}
            ></div>
            <ul
              className={`home-navigation hide-screen ${
                showMobileNav && "show-home-navigation"
              }`}
            >
              {/* <li className="mobile-nav-link active-li">
                {" "}
                <a
                  className=""
                  href="http://localhost/boxigo_customer_portal/packers-and-movers-relocation-services"
                >
                  {" "}
                  Relocation{" "}
                </a>{" "}
              </li>
              <li className="mobile-nav-link active-li">
                {" "}
                <a
                  className=""
                  href="http://localhost/boxigo_customer_portal/storage-services"
                >
                  {" "}
                  Storage Space{" "}
                </a>{" "}
              </li> */}
              <li>
                <a className="" href={BOXIGO_WEBSITE_LINKS.about_us}>
                  About Us
                </a>
              </li>
              <li>
                <Link to={navigationsLinks.move_details_page}>Get Quote</Link>
              </li>
              <li>
                <a className="" href={BOXIGO_WEBSITE_LINKS.vendors}>
                  Vendors
                </a>
              </li>
              <li>
                <a className="" href={BOXIGO_WEBSITE_LINKS.contact_us}>
                  Contact
                </a>
              </li>
              <li>
                <UncontrolledDropdown className="d-inline">
                  <DropdownToggle tag="a" caret>
                    FAQ
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      tag="a"
                      href={BOXIGO_WEBSITE_LINKS.customer_faq}
                    >
                      Customer FAQ
                    </DropdownItem>

                    <DropdownItem
                      tag="a"
                      href={BOXIGO_WEBSITE_LINKS.vendor_faq}
                    >
                      Vendor FAQ
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>
              <li>
                {userInfo.loggedIn === false && (
                  <UncontrolledDropdown className="d-inline">
                    <DropdownToggle tag="a" className="" caret>
                      Login
                    </DropdownToggle>
                    <DropdownMenu>
                      {/* <DropdownItem tag="div" href="/blah">
                      Customer
                    </DropdownItem>
                    <DropdownItem tag="div" href="/blah">
                      Vendor
                    </DropdownItem> */}
                      <Link to="/login" className="dropdown-item">
                        Customer
                      </Link>
                      <a
                        href={BOXIGO_WEBSITE_LINKS.vendor_login}
                        className="dropdown-item"
                      >
                        Vendor
                      </a>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
                {userInfo.loggedIn === true && (
                  <UncontrolledDropdown className="d-inline">
                    <DropdownToggle tag="a" caret>
                      <img
                        src={
                          "https://ui-avatars.com/api/?name=" +
                          userInfo.customerName.trim().split(" ")[0] +
                          "&color=fff&background=f27051&size=35&rounded=true&length=1&bold=true"
                        }
                        alt=""
                        className="img-fluid"
                      />
                    </DropdownToggle>
                    <DropdownMenu>
                      <Link
                        to={navigationsLinks.dashboard_page}
                        className="dropdown-item"
                      >
                        My Moves
                      </Link>
                      <Link
                        to={navigationsLinks.customer_profile_page}
                        className="dropdown-item"
                      >
                        My Profile
                      </Link>
                      <Link
                        to={navigationsLinks.move_details_page}
                        className="dropdown-item"
                      >
                        Make Estimate
                      </Link>
                      <button
                        onClick={() => {
                          dispatch(
                            thunkLogoutUser({
                              status: false,
                              history: history,
                            })
                          );
                        }}
                        className="dropdown-item"
                      >
                        LOGOUT
                      </button>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
              </li>
              <li className="contact-mobile-view d-none">
                <a
                  // onclick="return gtag_report_conversion('tel:+918884448117');"
                  href="tel:+918884448117"
                  className=""
                >
                  <img
                    src={`${config.customerPortal}assets/images/home/whatsapp.png`}
                    alt="Whatsapp Us"
                  />{" "}
                  +91 88844 48117{" "}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </>
  );
  return JSX;
}
